export const ROUTE_CONSTANTS = {
  DASHBOARD: '/dashboard',
  LOGIN: '/login',
  SIMULATDED_TESTS: '/simulated-tests',
  SIMULATDED_TESTS_QUESTIONS: '/simulated-tests/simulated-questions',
  QUESTIONS: '/questions',
  SUBTOPIC: '/questions/subtopic',
  TOPIC_QUESTIONS: '/questions/subtopic/questions',
  RESET_PASSWORD: '/reset-password',
  ROOT: '/',
  TERMS_OF_USE: '/terms-of-use',
  SIGNUP: '/signup',
  VIDEOS: '/videos',
  VIDEOS_LISTS: '/videos-list',
  DISPLAY_FLASH: '/display-flashcards',
  DASHBOARD_SIMULATED_TEST: '/dashboard/simulated-test-results',
  LEADERBOARD: '/dashboard/leaderboard',
  ACHIEVEMENTS: '/dashboard/achievements',
  CHALLENGES: '/dashboard/challenges',
  COURSE_MANUAL: '/dashboard/course-manual',
  PURCHASE_P2P: '/dashboard/purchase-p2p',
  TEST_SPEED: '/dashboard/test-speed',
  TUTORIAL: '/dashboard/tutorial',
  CHANGE_PASSWORD: '/dashboard/change-password',
};
